import { apiConstants } from '../../apiConstant'
import { formDataCommonFunctionPut, serviceCall } from '../../serviceCall'

const deleteGuestUserLinkApi = (data, callback, errorCallBack) => { 
  return async (dispatch) => {
    formDataCommonFunctionPut(data, apiConstants.USER.DELETE_GUEST_USER_LINK)
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default deleteGuestUserLinkApi
